export default {"src":"/_next/static/media/tie.7c02eeb9.svg","height":18,"width":20,"blurWidth":0,"blurHeight":0};